import React, { useContext } from 'react';

import { DashboardContext } from '../DashboardProvider';
import { GadgetsView } from './Gadgets.view';

const Gadgets: React.FC = () => {
  const { projectId, isQAlityConfigured, isOnboardingGadgetOpened } =
    useContext(DashboardContext);

  return (
    <GadgetsView
      projectId={projectId}
      isQAlityConfigured={isQAlityConfigured}
      isOnboardingGadgetOpened={isOnboardingGadgetOpened}
    />
  );
};

export default Gadgets;
